import { toNaiveISO } from '../date';

type AnyObj = Record<string, any>;

// OPTIONAL: crude padding to "look wider" in some viewers.
// Many CSV viewers trim, so widths are not reliable in CSV.
// If you want this, set PAD_CELLS=true.
const PAD_CELLS = false;

function padCell(val: string) {
  if (!PAD_CELLS) return val;
  // Append spaces roughly equal to length (very rough "double width" feel)
  const len = val?.length ?? 0;
  return val + ' '.repeat(Math.min(40, len)); // cap to avoid absurd sizes
}

// pick columns (ID removed)
export function buildFeedbacksCsv(rows: AnyObj[]) {
  const headers = [
    { key: 'createdAt', label: 'Date Received' },
    { key: 'type', label: 'Guest/Staff' },
    { key: 'additionalInfo.sentiment', label: 'Sentiment' },
    { key: 'additionalInfo.category', label: 'Category' },
    { key: 'additionalInfo.subCategory', label: 'Sub-category' },
    { key: 'action', label: 'Action' },
    { key: 'actionStatus', label: 'Action Status' },
    { key: 'description', label: 'Verbatim (root)' },
    { key: 'additionalInfo.description', label: 'Verbatim (additionalInfo)' },
    { key: 'additionalInfo.tripId', label: 'Trip ID' },
    { key: 'additionalInfo.itineraryId', label: 'Itinerary ID' },
    { key: 'createdBy.username', label: 'Created By' },
  ];

  const get = (obj: AnyObj, path: string) =>
    path.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : ''), obj);

  const escapeCell = (val: any) => {
    if (val === null || val === undefined) return '';
    const s = String(val);
    const needsQuotes = /[",\n]/.test(s);
    const escaped = s.replace(/"/g, '""');
    return needsQuotes ? `"${escaped}"` : escaped;
  };

  const headerLine = headers.map(h => escapeCell(h.label)).join(',');
  const lines = rows.map(r => {
    return headers.map(h => {
      let v: any = get(r, h.key);
      if (h.key === 'createdAt' && v) {
        try { v = toNaiveISO(v); } catch {}
      }
      return escapeCell(padCell(String(v ?? '')));
    }).join(',');
  });

  return '\uFEFF' + [headerLine, ...lines].join('\n');
}

export function downloadCsv(csv: string, filename = 'feedbacks.csv') {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
